import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c256e992")

_pushScopeId("data-v-c256e992")
const _hoisted_1 = {
  key: 0,
  class: "toc_ui__carName_main"
}
const _hoisted_2 = { class: "toc_ui__carName_body" }
const _hoisted_3 = { class: "toc_ui__carName_img" }
const _hoisted_4 = { class: "toc_ui__carName_msg" }
const _hoisted_5 = { class: "toc_ui__carName_text" }
const _hoisted_6 = { class: "toc_ui__carName_vin" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__line_main" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.state.reportMsg.RpZB())
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              src: _ctx.state.carImg,
              style: {"pointer-events":"none"}
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.state.carModel), 1),
            _createVNode("div", _hoisted_6, "VIN：" + _toDisplayString(_ctx.state.vin), 1)
          ])
        ]),
        _hoisted_7
      ]))
    : _createCommentVNode("", true)
})